import module from 'nominas/donaciones/module.js'

module.config(($stateProvider) => {
  $stateProvider.state('nominas.donaciones', {
    data: {title: 'Donaciones'},
    url: '/donaciones?{empresa}&{nomina}',
    resolve: {
      empresa: ($stateParams) => $stateParams.empresa,
      nomina: ($stateParams) => $stateParams.nomina,
      nominas: ($api, empresa) => {
        if (empresa) return $api.post('kendu/nominas/libroNominas/catalogo', {companies: [empresa]})
      },
      catalogos: ($catalogos, nominas) => $catalogos.$fetch()
        .then((catalogos) => ({
          Empresas: catalogos.Empresas.$select(),
          Nominas: nominas ? nominas.filter((item) => item.Status !== 'C') : undefined,
        })),
      data: (empresa, nomina, NominasDonaciones) => (empresa && nomina) ? NominasDonaciones.get(empresa, nomina) : null,
    },
    template: '<nominas-donaciones empresa="empresa" nomina="nomina" data="data" catalogos="catalogos"></nominas-donaciones>',
    controller: ($scope, empresa, nomina, data, catalogos) => {
      $scope.empresa = empresa
      $scope.nomina = nomina
      $scope.data = data
      $scope.catalogos = catalogos
    },
  })
})



// WEBPACK FOOTER //
// ./src/nominas/donaciones/routes/nominas-donaciones.js